import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Container, Row, Col, CardGroup, Card, CardBody } from 'reactstrap';
//import { Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
//import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
//import querystring from 'querystring';

import Language from '../../languages/spanish/';

class Login extends Component {
 constructor(props) {
  super(props);
  this.state = { }
 }

 render() {
  return (
   <div className="app flex-row align-items-center">
    <Container>
     <Row className="justify-content-center">
      <Col md="8">
       <CardGroup>
        <Card className="p-4">
         <CardBody>
          <p>{Language.Errors.needsupport}</p>
          <Link to="/login" className="px-0">{Language.Login.backtologin}</Link>
         </CardBody>
        </Card>
       </CardGroup>
      </Col>
     </Row>
    </Container>
   </div>
  );
 }

}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Auth/Forgotten.js